export default __webpack_public_path__ + "static/media/social-facebook.4d807306.svg";